import axios from 'axios';

//const API_URL = 'http://localhost:5000/api';
const API_URL = 'https://sdtxt.top/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Логин с axios для консистентности
export async function login(username, password) {
  try {
    debugger;
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  } catch (error) {
    // Разбор ошибки от сервера
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Login failed');
  }
}

export async function fetchLeads(token) {
  try {
    console.log(token);
    const response = await api.get('/leads', {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('API Response:', response);
    return response.data;
  } catch (error) {
    handleApiError(error);
    if (err.response?.status === 401) {
        localStorage.removeItem('token');        
        window.location.reload();
    }
  }
}

export async function updateLead(token, leadData) {
  try {    
    console.log('leadData перед отправкой:', leadData);
    debugger;
    const response = await api.put(`/leads/${leadData.id}`, leadData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Ошибка обновления лида:', error.response?.data);
    handleApiError(error);
  }
}

export async function deleteLead(token, id) {
  try {    
    const response = await api.delete(`/leads/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
}

export async function addLead(token, leadData) {
  try {
    const response = await api.post('/leads', leadData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log(error.response.data);
    handleApiError(error);
  }
}

// Вспомогательная функция для обработки ошибок
function handleApiError(error) {
  if (error.response && error.response.data && error.response.data.message) {
    throw new Error(error.response.data.message);
  } else if (error.message) {
    throw new Error(error.message);
  } else {
    throw new Error('Unknown API error');
  }
}

export default api;
